import { AdminPanelSettingsOutlined as AdminPanelSettingsOutlinedIcon } from '@mui/icons-material';

const AdminPanelOutline = (): JSX.Element => <AdminPanelSettingsOutlinedIcon fontSize="inherit" />;

export default AdminPanelOutline;
